import React from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import { LocalOfferOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { GlobalContext } from "../../context/GlobalContext";
import { UserContext } from "../../context/UserContext";

/** Redeem marketing promo codes for wallet credits. */
export default function PromoRedeemPanel({ lang }) {
  const theme = useTheme();
  const { hitAxios, showSnack } = React.useContext(GlobalContext);
  const { getUserData } = React.useContext(UserContext);
  const [code, setCode] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const redeem = async () => {
    if (!code.trim()) {
      showSnack?.(lang?.promoNeedCode || "Enter a promo code", false);
      return;
    }
    setLoading(true);
    try {
      const res = await hitAxios({
        path: "/api/user/redeem_promo",
        post: true,
        admin: false,
        obj: { code: code.trim() },
        showLoading: false,
        showSnackbar: false,
      });
      if (res?.data?.success) {
        showSnack?.(res.data.msg || "Credits added", true);
        setCode("");
        getUserData?.();
      } else {
        showSnack?.(res?.data?.msg || "Could not redeem code", false);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      elevation={0}
      sx={{
        mb: 2.5,
        borderRadius: 2.5,
        border: `1px solid ${theme.palette.divider}`,
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
        <Stack direction="row" spacing={1} alignItems="center" mb={1}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1.5,
              display: "grid",
              placeItems: "center",
              bgcolor: alpha(theme.palette.warning.main, 0.12),
              color: theme.palette.warning.dark,
            }}
          >
            <LocalOfferOutlined fontSize="small" />
          </Box>
          <Box>
            <Typography fontWeight={800}>
              {lang?.promoRedeemTitle || "Redeem promo code"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {lang?.promoRedeemSub ||
                "Have a partner or launch code? Add the credits to your wallet."}
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25} mt={1.5}>
          <TextField
            size="small"
            fullWidth
            placeholder="LAUNCH100"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            inputProps={{
              style: { fontFamily: "ui-monospace, Menlo, monospace", fontWeight: 700 },
            }}
          />
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={redeem}
            sx={{ textTransform: "none", fontWeight: 800, px: 2.5, flexShrink: 0 }}
          >
            {lang?.promoRedeemCta || "Redeem"}
          </LoadingButton>
        </Stack>
      </CardContent>
    </Card>
  );
}
